import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";
import {BigCoverMapRegions} from "../../../../components/coverageMap/CoverageMap.ts";
import Routing from "../../../../Routing.ts";
import CoverageMapContainer from "../../../../components/coverageMap/CoverageMapContainer.tsx";

export default function TeknikerCoaxArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <p>
                            Når du bestiller 1.000 Mbit via kabel-tv stikket, skal dit stik på adressen være opdateret med stikket DOCSIS 3.1, før stikket kan trække 1.000 Mbit.
                        </p>
                        <p>
                            Hvis dit stik ikke er opdateret, tilbyder vi at du gratis kan få opdateret stikket på din adresse.
                        </p>
                        <p>
                            Opdateringen kræver et teknikerbesøg, hvor en tekniker opgraderer dit stik til et nyt DOCSIS 3.1 stik.
                            Med et DOCSIS 3.1-stik kommer din forbindelse over på en del af nettet med langt mere kapacitet.
                        </p>
                        <p>
                            Vil du have 1.000 Mbit og samtidig få skiftet dit stik helt gratis?<br/>
                            Så tjek din adresse herunder.
                        </p>
                        <p>
                            <Link
                                to={Routing.Order}
                                className={'address-button button button--montserrat rounded'}
                                rel={'nofollow'}
                            >Tjek din adresse her</Link>
                        </p>
                    </div>
                </div>

                <div className="article">
                <div className="paragraph">
                        <h2>Skal jeg være hjemme når teknikeren kommer?</h2>
                        <p>
                            Når du får besøg af en tekniker, skal der være en person til stede på adressen, som kan lukke teknikeren ind.
                            Personen skal være myndig og fyldt 18 år. Hvis der ikke er en myndig person til at åbne op for teknikeren, bliver du opkrævet 699 kr. for et forgæves teknikerbesøg.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Kan jeg ændre min teknikertid?</h2>
                        <p>
                            Du modtager en dato for teknikerbesøget i god tid, så du ved hvornår du skal være hjemme.
                            Teknikeren ringer til dig 30 minutter, før han ankommer til adressen på selve dagen.
                        </p>
                        <p>
                            Hvis du ønsker at ændre datoen, kan du få en ny tid ved at ringe til os på <a href="tel:+4588772000">8877&nbsp;2000</a> minimum 2 dage før den oprindelige dato.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er leveringstiden, når man skal have en tekniker ud?</h2>
                        <p>
                            Oftest går der 2-3 uger fra du bestiller til dit nye internet er klar til brug.
                            Det afhænger af, om du skal have besøg af en tekniker.
                        </p>
                        <p>
                            Hvis du allerede har fået opsat et nyt kabel-tv-stik på adressen, kan du se din leveringstid lige <Link to="/hjaelp/bestilling/leveringstid">her</Link>.
                        </p>
                    </div>
                </div>

                <div className="article article--connect">
                    <div className="paragraph">
                        <h2>Er der kabel-tv-stik i mit område?</h2>
                        <p>
                            På vores dækningskort kan du se, i hvilke områder der er mulighed for internet via kabel-tv-stik.
                        </p>
                        <CoverageMapContainer regionPreset={BigCoverMapRegions.COAX} fiberMapOnly={false} static={true}/>
                        <p className="coverage-map-disclaimer">
                            Vi kan ikke garantere at kunne levere til alle adresser i de markerede områder.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "bestilling",
                        "article": "leveringstid",
                        "name": "Leveringstid på internet"
                    },
                    {
                        "category": "bestilling",
                        "article": "kan-jeg-faa-1000-mbit",
                        "name": "Kan jeg få 1.000 Mbit?"
                    },
                    {
                        "category": "bestilling",
                        "article": "opsig-eksisterende-abonnement",
                        "name": "Skal jeg selv opsige mit eksisterende abonnement?"
                    },
                    {
                        "category": "udstyr",
                        "article": "hvilken-router-foelger-med",
                        "name": "Hvilken router følger med?"
                    }
                ]}
            />
        </>
    )
}
